import axios from 'axios';
import * as endpoint from '../../../endpoint';
import { SUCCESS_API_CREATE_OPERATOR } from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * 新規ユーザーをAPI呼び出しで作成する関数
 *
 * @param {string} apiToken - 認証に使用するAPIトークン。
 * @param {object} apiPrams - リクエストボディに送信されるパラメータ。
 * @example
 * dispatch(createOperators(apiToken, {
 *   name: 'オプティム 太郎',
 *   email: 'sf_user01@example.com',
 *   role: '10',
 *   license: {
 *     isActiveUser: true,
 *     isRemoteSupport: true,
 *   }
 * }));
 */
const createOperator = (apiToken, apiPrams) => dispatch => {
  consolelog('[API CALL] createOperators()', apiPrams);
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_CREATE_OPERATOR;
  const { cancelToken, cancelTokenKey } = createCancelToken('createOperators');
  const params = {
    cancelToken,
    ...apiPrams,
  };
  return axios
    .post(url, params)
    .then(() => {
      delCancelToken(cancelTokenKey);
      dispatch({
        type: SUCCESS_API_CREATE_OPERATOR,
      });
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default createOperator;
